"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
/**
 * Returns the action bar of the Dialog.
 * @returns React.ReactElement
 */
exports.DialogActionsBar = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { className: "k-dialog-buttongroup k-dialog-button-layout-stretched" }, children));
};
//# sourceMappingURL=DialogActionsBar.js.map


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-react-dialogs@3.18.0_react-dom@16.14.0_react@16.14.0__react@16.14.0/~/@progress/kendo-react-dialogs/dist/npm/DialogActionsBar.js
// module id = 321
// module chunks = 0